const onMessageSend = (e) => {
  if (e.origin !== 'https://www.galaxy.com' && e.origin !== 'https://glxy.galaxydigital.io' && e.origin !== 'https://go.pardot.com' && e.origin !== 'https://research.galaxy.com' && e.origin !== 'https://go.galaxy.com') {
    return;
  }

  const iframe = document.querySelector('[data-ref="pardot-iframe"]');
  const {event, data} = e.data;

  switch (event) {
  case 'setHeight':
    iframe.style.height = `${data}px`;
    break;
  }
};

const init = () => {
  window.addEventListener('message', onMessageSend);
};

init();
